export default __webpack_public_path__ + "static/media/Authentic-Sans-150.7953bfb6.woff2";